import Toggle from './Toggle';
import { BORDER_STYLES } from '../../constants/styles';

function ImageComparison({ 
  oldImage, 
  newImage, 
  oldAlt = 'Old version', 
  newAlt = 'New version',
  showNew = true,
  onToggle,
  leftLabel = 'Old',
  rightLabel = 'New',
  ariaLabel = 'Toggle image view'
}) {
  if (!oldImage && !newImage) return null;

  const imageClassName = `w-full h-auto ${BORDER_STYLES.rounded} ${BORDER_STYLES.default}`;

  return (
    <div className="mt-8">
      <Toggle
        leftLabel={leftLabel}
        rightLabel={rightLabel}
        isRight={showNew}
        onChange={onToggle}
        ariaLabel={ariaLabel}
      />
      <div className="relative">
        {showNew && newImage ? (
          <img
            key="new"
            src={newImage}
            alt={newAlt}
            className={imageClassName}
          />
        ) : oldImage ? (
          <img
            key="old"
            src={oldImage}
            alt={oldAlt}
            className={imageClassName}
          />
        ) : null}
      </div>
    </div>
  );
}

export default ImageComparison;

